<template>
  <div class="act-btn">
    <div class="act-btn-main">
      <div class="act-btn-title">
        {{u.type_name}}: {{u[u.type + '_name']}}
      </div>
      <div class="act-btn-label" v-if="u.type === 'medicine'">
        <span> 用法: {{ u.usage }} </span>
        <span> 用量: {{ u.dosage }} </span>
        <span> 单位: {{ u.unit }} </span>
      </div>
      <div class="act-btn-label"
       v-if="u.type === 'medicine' && u.extra.fact_dosage !== null && u.extra.fact_dosage !== undefined && u.extra.fact_dosage != u.dosage">
        <span>实际用量: <span style="color: #ff9e00;font-size: 14px;font-weight: 500">{{u.extra.fact_dosage}}</span> {{u.unit}}</span>
      </div>
    </div>
    <div class="act-btn-value" v-if="u.type === 'survey' || u.type === 'article'">
      <el-divider direction="vertical"></el-divider>
      <div class="act-btn-oper" @click.stop="handleClickUrl">
        查看
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    u: {
      type: Object,
      default: () => ({})
    },
    is_redirect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  methods: {
    handleClickUrl() {
      if (this.u.type === 'survey' && this.is_redirect) {
        this.$store.commit("setAllSelectedKeys", {
          type: "add",
          name: "questionIframe",
          title: this.u.survey_name,
          key: `${this.u.extra.survey_url}`,
          extra: {
            url: this.u.extra[this.u.type + '_url']
          },
        });
      } else {
        const a = document.createElement('a')
        a.setAttribute('href', this.u.extra[this.u.type + '_url'])
        a.setAttribute('target', '_blank')
        a.setAttribute('id', 'link-temp')
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(document.getElementById('link-temp'))
      }
    }
  }
}
</script>
<style lang="less">
.act-btn{
  padding: 12px;
  display: flex;
  align-items: center;
  color: rgb(130, 143, 164);
  font-weight: normal;
  &-main{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  &-title{
    font-size: 14px;
  }
  &-label{
    color: rgba(130, 143, 164, 0.7);
    span{
      padding-right: 6px;
      font-size: 13px;
    }
  }
  &-value{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
  }
}
</style>
